import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function PlayBackButton() {
	const navigate = useNavigate()

	return (
		<button
			type='button'
			onClick={() => navigate(-1)}
			className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-border bg-secondary text-foreground transition-colors hover:bg-accent'
			aria-label='Go back'
		>
			<ChevronLeft className='h-5 w-5' />
		</button>
	)
}
